var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2 11.2958C22.2 11.7261 21.9582 12.1199 21.5744 12.3147L14.6764 15.8149C13.8012 16.259 12.7317 15.9095 12.2876 15.0343C11.8436 14.1593 12.1928 13.09 13.0677 12.6458L17.6552 10.3161L13.0662 7.98294C12.1882 7.53654 11.8379 6.46314 12.2836 5.5848C12.7296 4.70594 13.8035 4.35499 14.6824 4.80094L21.5737 8.2977C21.9575 8.4924 22.1993 8.88624 22.1993 9.31656V9.35988C22.1997 9.37176 22.2 9.3837 22.2 9.39576V11.2958Z",
    fill: "url(#paint0_linear_6822_4538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80006 14.8957C1.80006 15.3261 2.04187 15.7199 2.42564 15.9146L9.32363 19.4148C10.1988 19.8589 11.2683 19.5094 11.7124 18.6342C12.1564 17.7592 11.8071 16.6899 10.9324 16.2457L6.34499 13.9161L10.9338 11.583C11.8118 11.1366 12.162 10.0632 11.7164 9.1849C11.2704 8.30602 10.1964 7.95508 9.31763 8.40106L2.42634 11.8978C2.04258 12.0925 1.80078 12.4863 1.80077 12.9167L1.80076 12.9598C1.80029 12.9717 1.80005 12.9836 1.80005 12.9957L1.80006 14.8957Z",
    fill: "url(#paint1_linear_6822_4538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6822_4538",
    x1: 17.145,
    y1: 4.60742,
    x2: 17.145,
    y2: 16.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6822_4538",
    x1: 6.85497,
    y1: 8.20752,
    x2: 6.85497,
    y2: 19.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009980"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.415ec7ac871b82c58b2a5bc8e64fa92e.svg";
export { ForwardRef as ReactComponent };